import { APIPath } from '../constant'
import { CommonUtility } from '../common'
import { BaseService } from './base'

// GET Dashboard/Home and its Settings (backend: docs/dashboard/Home-Dashboard-API.md in EAuditor.App).
class HomeDashboard {
    getHome({ view, range = 30, customerId } = {}) {
        const query = { range }
        if (view) query.view = view
        if (customerId) query.customerId = customerId
        return BaseService.get(
            `${APIPath.homeDashboard}?${CommonUtility.objectToParams(query)}`,
        )
    }

    getSetting(refresh = false) {
        return BaseService.get(
            `${APIPath.homeDashboardSetting}${refresh ? '?refresh=true' : ''}`,
        )
    }

    saveSetting({ DashboardType, UnitWord, FindingAgeDays, Blocks }) {
        return BaseService.post(APIPath.homeDashboardSetting, {
            DashboardType,
            UnitWord: UnitWord || null,
            FindingAgeDays,
            Blocks,
        })
    }

    getFindingAnswers() {
        return BaseService.get(APIPath.homeDashboardFindingAnswers)
    }

    saveFindingAnswers(answers) {
        return BaseService.post(APIPath.homeDashboardFindingAnswers, {
            Answers: answers || [],
        })
    }
}

const HomeDashboardService = Object.freeze(new HomeDashboard())
export { HomeDashboardService }
